module.exports = __webpack_public_path__ + "img/techPractices.c09c7a18.svg";